import { useState } from 'react';
import PropTypes from 'prop-types'; 
import Tabs from './Tabs/Tabs';
import Upload from './DocumentTranslation/Upload';
import Playground from './TextTranslation/Playground';

const HeroSection = ({ onViewStateChange }) => {
  const [activeTab, setActiveTab] = useState('Document Translation');
  const [isDocumentUploaded, setIsDocumentUploaded] = useState(false);

  const handleViewStateChange = (viewState) => {
    if (onViewStateChange) {
      onViewStateChange(viewState);
    }
  };

  return (
    <section className="bg-pl_bg_light_3 text-pl_txt_light_1 h-full flex flex-col">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col h-full pt-4 pb-16">
        <div className="text-left mb-4 xs:mb-2">
          <Tabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            isDocumentUploaded={isDocumentUploaded}
          />
        </div>
        <div className="bg-pl_bg_light_3 text-pl_txt_light_1 p-4 md:p-6 lg:p-6 rounded-2xl shadow-xl border max-w-7xl mx-auto w-full flex-1">
          {activeTab === 'Document Translation' ? (
            <Upload 
              onUploadSuccess={() => setIsDocumentUploaded(true)}
              onViewStateChange={handleViewStateChange}
            />
          ) : (
            <Playground />
          )}
        </div>
      </div>
    </section>
  );
};


HeroSection.propTypes = {
  onViewStateChange: PropTypes.func, // use `.isRequired` if necessary
};

export default HeroSection;
